import React from 'react';
import {
  Table,
  TableHeader,
} from '@fortress-technology-solutions/fortress-component-library/Organisms_Fortress';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import DocumentTitle from 'react-document-title';

import useBaseTableProps from '../../hooks/useBaseTableProps';
import TableLayout from '../../components/TableLayout';
import { useCentralizedDelinquentAndPrepaid } from './hooks';

// FIXME: this function should be extracted since it's duplicated in ManageProspectsV2
import withReduxStore from '../ManageDelinquency/withReduxStore';

const NAME = 'centralized-manage-delinquent-and-prepaid';
const TITLE = 'Manage Delinquent and Prepaid';

function CentralizedManageDelinquency({ organizationId, intl, locale, store }) {
  const baseTableProps = useBaseTableProps();
  const {
    allColumnsHidden,
    columnOptions,
    count,
    dateState,
    filterState,
    filterTypeState,
    filteredHeaders,
    footerRow,
    handleColumnChange,
    handleDateSubmit,
    handleFilterChange,
    handleFilterTypeChange,
    handleSearchSubmit,
    handleSortChange,
    isLoading,
    name,
    onCSVButtonClick,
    order,
    orderBy,
    rows,
    searchState,
    selectedColumns,
    totalCount,
  } = useCentralizedDelinquentAndPrepaid({
    organizationId,
    NAME,
    intl,
    locale,
    store,
  });
  return (
    <DocumentTitle data-testid={NAME} title={TITLE}>
      <TableLayout name={name} childrenElementsHeight={50 + 8}>
        {(height) => (
          <>
            <TableHeader title={TITLE} count={count} totalCount={totalCount} />
            <Table
              {...baseTableProps}
              allColumnsHidden={allColumnsHidden}
              columnOptions={columnOptions}
              count={count}
              dateState={dateState}
              filterState={filterState}
              filterTypeState={filterTypeState}
              footerRow={footerRow}
              handleColumnChange={handleColumnChange}
              handleDateSubmit={handleDateSubmit}
              handleFilterChange={handleFilterChange}
              handleFilterTypeChange={handleFilterTypeChange}
              handleSearchSubmit={handleSearchSubmit}
              handleSortChange={handleSortChange}
              headers={filteredHeaders}
              height={height}
              isLoading={isLoading}
              name={name}
              onCSVButtonClick={onCSVButtonClick}
              order={order}
              orderBy={orderBy}
              rows={rows}
              searchState={searchState}
              selectedColumns={selectedColumns}
              totalCount={totalCount}
            />
          </>
        )}
      </TableLayout>
    </DocumentTitle>
  );
}

export const mapStateToProps = (state): Object => {
  const { app, languageProvider } = state;
  return {
    organizationId: app?.currentUser?.user?.organizationId ?? '',
    locale: languageProvider.locale,
  };
};

export default connect(
  mapStateToProps,
  null,
)(injectIntl(withReduxStore(CentralizedManageDelinquency)));
